import React, { useState } from 'react'
import styles from './styles.module.scss'
import { getDescryptedMedia } from 'srcReact/helpers/utils'
import { useIntersect } from 'srcReact/helpers/hooks/useIntersect'
import ProgressiveImg from '../ProgressiveImg'
import ImageLoader from '../ImageLoader'

function MediaImage({
  files,
  file,
  index,
  showImageModal,
  showPlainImageModal,
  isFilesOwner,
  size,
  entityId,
  className,
  parentElementId = '',
  feed,
  feedLevel
}) {
  const [decryptedImage, setDecryptedImage] = useState('')
  const [ref, entry] = useIntersect(
    {
      root: parentElementId ? document.querySelector(`#${parentElementId}`) : null,
      rootMargin: '40%'
    },
    () => {
      if (file && file.path) {
        const { url, is_original, original_tag, mime_type } = file
        getDescryptedMedia(url, is_original, original_tag, mime_type, file.id ?? file.id_file ?? file.file_id).then(
          (data) => {
            setDecryptedImage(data.img)
          }
        )
      }
    }
  )
  return decryptedImage ? (
    <button
      id={file.id}
      ref={ref}
      type='button'
      key={file.id}
      className={`${styles.commentImageButton} ${className}`}
      aria-label={file.name}
      onClick={() =>
        showPlainImageModal
          ? showPlainImageModal(file)
          : showImageModal && showImageModal(file, index, files, isFilesOwner, entityId, feed, feedLevel)
      }>
      <ProgressiveImg
        src={decryptedImage}
        placeholderSrc={file.thumbnail_url}
        className={`${styles.commentImage} ${styles[size]} `}
      />
    </button>
  ) : (
    <ImageLoader size={size} refObject={ref} className={`${styles[size]} ${styles.imageLoader}`} />
  )
}

export default MediaImage
